import { Navigate, useLocation } from 'react-router-dom'
import { NotFoundState } from '../components/States'
import { useSession } from '../lib/sessionContext'
import { isAdminSession } from './navigation'

/**
 * An admin address that matches no page — said inside the panel, not swapped for its home
 * (Taiga #1547). A learner has no panel to be told in, so they are told inside the portal:
 * the same address under `/portal`, which matches nothing there either. Sending them to
 * `/portal` itself landed on the programmes — the very redirect the issue is about.
 */
export default function NotFoundPage() {
  const { session } = useSession()
  const { pathname } = useLocation()
  if (!isAdminSession(session)) return <Navigate to={`/portal${pathname}`} replace />
  return <NotFoundState home="/" />
}
